import HighlightStory from './HighlightStory'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class HighlightContent extends PureComponent {
  static propTypes = {
    highlightStories: PropTypes.array.isRequired,
    template: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      focusedHighlightStory: null
    }
  }

  render() {
    let { highlightStories, template } = this.props
    const { focusedHighlightStory } = this.state
    const templateClasses = classNames(
      'clearfix',
      `insight-layout-${template.size}-item`,
      template.name
    )

    highlightStories = highlightStories.sort((a, b) => a.orderIdx - b.orderIdx)

    return (
      <div className="insight-template-container clear-both">
        <div className={templateClasses}>
          {highlightStories.map(highlightStory => (
            <HighlightStory
              key={highlightStory.id}
              highlightStory={highlightStory}
              isFocused={focusedHighlightStory === highlightStory}
              onLoseFocus={() => this.setState({ focusedHighlightStory: null })}
              onFocus={() =>
                this.setState({ focusedHighlightStory: highlightStory })
              }
            />
          ))}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/HighlightContent.js